import { render, staticRenderFns } from "./CustomerViewGlobal.vue?vue&type=template&id=2ff41f7c"
import script from "./CustomerViewGlobal.vue?vue&type=script&lang=js"
export * from "./CustomerViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports